import axios from "axios/index";

const CONTENT_SERVICE = process.env.REACT_APP_PREFIX_CONTENT_SERVICE;
const CONTENT_SERVICE_PREFIX = `${CONTENT_SERVICE}/api/v1`;

const pageCache = {};

const getUrlWithoutLang = () => {
    return window.location.pathname.replace(new RegExp(`^/(en|ru|zh|de|es|it)`), '');
};

const _loadPageByUrl = ({lang}) => {
    const link = `${CONTENT_SERVICE_PREFIX}/content/pages/by-url`;

    return new Promise((resolve, reject) => {
        axios.get(link, {
            params: {
                url: getUrlWithoutLang(),
                lang
            }
        }).then(data => {
            if (data && data.status && [400, 401, 403, 404, 500].includes(data.status)) {
                reject(data);
                return;
            }

            resolve(data);
        })
            .catch(error => {
                reject(error);
            });
    });
};

export const loadPageByUrl = ({lang}) => {
    const options = {url: getUrlWithoutLang, lang};
    const key = JSON.stringify(options);

    if (key in pageCache) {
        return pageCache[key];
    }

    pageCache[key] = _loadPageByUrl(options);

    return pageCache[key];
};
